export default "__VITE_ASSET__$6drIvbL__"